export default function NavBar() {
  return <div />;
}
